export default function CircularLoading() {
  return (
    <div className="w-full flex flex-col justify-center items-center min-h-dvh bg-secondary-background">
      <div className="relative w-8 h-8">
        <div className="absolute top-0 left-0 w-full h-full border-4 border-primary/20 rounded-full"></div>
        <div className="absolute top-0 left-0 w-full h-full border-4 border-transparent border-t-primary rounded-full animate-spin"></div>
      </div>
    </div>
  );
}
